var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.shouldShowBackButton)?_c('BackButton'):_vm._e(),_c('router-view'),(_vm.shouldShowNavigation)?_c('BottomNavigation'):_vm._e(),_c('NotificationToast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }